// =============================================================================
// PROJECT DATA
// Single source of truth for all project information used across the site.
// =============================================================================

// Thumbnails / hero images
import AuburnRoadMain from "../images/case-studies/auburn-road/arv.png";
import AuburnRoadThumb from "../images/case-studies/auburn-road/arv-main.png";
import CUACCards from "../images/cuac-card-image@2x-100.jpg";
import MillennialBodyImageArt from "../images/case-studies/millennial-body-image/trap-bright.png";
import NightToShineThumb from "../images/case-studies/night-to-shine/nts.jpg";

// Auburn Road gallery
import AuburnRoadLogo from "../images/case-studies/auburn-road/main-logo.svg";
import AuburnRoadFeatherbed from "../images/case-studies/auburn-road/featherbed-winebotle-label.jpg";
import AuburnRoadLonghorn from "../images/case-studies/auburn-road/longhorn-can-label.jpg";
import AuburnRoadRattlesnakeCan from "../images/case-studies/auburn-road/rattlesnake-can-label.jpg";
import AuburnRoadRattlesnakeMockup from "../images/case-studies/auburn-road/rattlesnake-mockup.jpg";

// Night to Shine gallery
import NightToShineFullSite from "../images/case-studies/night-to-shine/nts.png";

const projects = [
  {
    id: "auburn-road",
    title: "Auburn Road Vineyards",
    category: "Branding + Website",
    outlineStyle: "gradient-pink",
    // Short meta line for cards (FeaturedWork)
    meta: "Branding • Web design • Development • CMS",
    // Images
    thumb: AuburnRoadThumb,
    heroImage: AuburnRoadMain,
    // Descriptions
    shortDesc:
      "Branding and a refined web experience that feels modern, welcoming, and easy to navigate on any device.",
    summary:
      "Branding and a refreshed web presence designed to feel premium, welcoming, and easy to navigate across devices.",
    // Detail fields for modal
    services: [
      "Branding",
      "Web design",
      "Web development",
      "Graphic design",
      "Product label design",
      "CMS integration",
    ],
    outcomes: [
      "Clearer navigation for events, tastings, and wine club",
      "Stronger visual hierarchy and modern layout",
      "Mobile-friendly experience",
    ],
    // Gallery images for modal
    gallery: [
      { src: AuburnRoadLogo, alt: "Auburn Road Vineyards logo", wide: true },
      { src: AuburnRoadFeatherbed, alt: "Featherbed wine bottle label design" },
      { src: AuburnRoadRattlesnakeCan, alt: "Rattlesnake can label design" },
      { src: AuburnRoadLonghorn, alt: "Longhorn can label design" },
      { src: AuburnRoadRattlesnakeMockup, alt: "Rattlesnake can mockup" },
    ],
    // Featured on homepage?
    featured: true,
  },
  {
    id: "cuac",
    title: "CUAC",
    category: "Branding + Design",
    outlineStyle: "black",
    meta: "Branding • Graphic design",
    thumb: CUACCards,
    heroImage: CUACCards,
    shortDesc:
      "Brand and design work built for consistency across print and digital touchpoints.",
    summary:
      "Branding and graphic design work built for consistency across print and digital touchpoints.",
    services: ["Branding", "Graphic design"],
    outcomes: [
      "Cohesive visual system across collateral",
      "Clearer, more consistent brand presence",
    ],
    gallery: [],
    featured: true,
  },
  {
    id: "millennial-body-image-podcast",
    title: "Millennial Body Image Podcast",
    category: "Branding + Design",
    outlineStyle: "blue-purple",
    meta: "Branding • Graphic design",
    thumb: MillennialBodyImageArt,
    heroImage: MillennialBodyImageArt,
    shortDesc:
      "Visual identity and graphic design that keeps the brand consistent across episodes and platforms.",
    summary:
      "Branding and graphic design built to keep the show's visual identity cohesive across platforms.",
    services: ["Branding", "Graphic design"],
    outcomes: [
      "Consistent visual identity",
      "Clearer, more recognizable brand",
    ],
    gallery: [],
    featured: false,
  },
  {
    id: "night-to-shine",
    title: "Night to Shine",
    category: "Web design + Development",
    outlineStyle: "black",
    meta: "Web design • Web development • Hosting & DNS",
    thumb: NightToShineThumb,
    heroImage: NightToShineThumb,
    shortDesc:
      "Updated website and hosting setup that makes it easy to manage event details and registrations year after year.",
    summary:
      "A refreshed Night to Shine website with clean information architecture, responsive layouts, and a reliable hosting and DNS setup that keeps event information easy to find and simple to update.",
    services: [
      "Web design",
      "Web development",
      "Hosting & DNS setup",
    ],
    outcomes: [
      "Modern, responsive event website",
      "Simpler updates for annual event details",
      "Stable hosting and DNS configuration",
    ],
    gallery: [
      { src: NightToShineFullSite, alt: "Night to Shine full website design", wide: true },
    ],
    featured: true,
  },
];

export default projects;

// Helper: get only featured projects
export const getFeaturedProjects = () => projects.filter((p) => p.featured);

// Helper: find a project by ID
export const getProjectById = (id) => projects.find((p) => p.id === id) || null;
